import { Typography, colors, Stack, ColorVariant, getRecipeColor, useModal } from '@ui-components/neo.tax';
import React from 'react';

import { RdProject, RdProjectTeamMember } from '@neo.tax/rd/hooks';

import { EditQreExpenseAllocationModalLoader } from '../qre-allocation/EditQreExpenseAllocationModalLoader';
import { Percentage } from './rd-project-team-members';

interface RdTeamMemberAllocationProps {
  rdProject: RdProject;
  teamMember: RdProjectTeamMember;
  variant: ColorVariant;
}

export const RdTeamMemberAllocation = ({
  rdProject,
  teamMember,
  variant,
}: RdTeamMemberAllocationProps): React.ReactElement => {
  const { isOpen, toggle } = useModal();

  return (
    <>
      <Stack direction="row" justifyContent="end" space={1} fullWidth>
        <Percentage onClick={toggle} fontSize="sm" color={getRecipeColor(variant, 'whiteBg').text}>
          {teamMember.allocationPercent}
        </Percentage>
        <Typography fontSize="sm" color={colors.gray[500]}>
          %
        </Typography>
      </Stack>
      <EditQreExpenseAllocationModalLoader
        isOpen={isOpen}
        close={toggle}
        rdExpenseId={teamMember.rdExpenseId}
        selectedRdProject={rdProject}
      />
    </>
  );
};
